import React, { useEffect } from 'react';
import { Box, Divider, Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';

import { useWhyDidYouUpdate } from 'src/utils/hooks';
import {
  useSalesforceProductionObjectsTarget,
  useSalesforceProductionProfilesTarget,
  useTargetAppsSalesforceProduction,
} from '@Policy/hooks';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { PolicyHolderTypeEnum } from '@Policy/utils/types';

export const ObjectsTargetSalesforceProduction = () => {
  const props = useSalesforceProductionObjectsTarget();
  useWhyDidYouUpdate('ObjectsTargetSalesforceProduction', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

export const AppsTargetSalesforceProduction = () => {
  const props = useTargetAppsSalesforceProduction();
  useWhyDidYouUpdate('AppsTargetSalesforceProduction', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

export const ProfilesTargetSalesforceProduction = () => {
  const props = useSalesforceProductionProfilesTarget();
  useWhyDidYouUpdate('ProfilesTargetSalesforceProduction', {
    ...props,
  });
  return <TargetUserGroups {...props} />;
};

export const TargetProduction = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const holderType = policySelector((s) => s.holderType);
  const policyTarget = policySelector((s) => s.policyTargetSalesforce);
  const setTempVars = contextSelector((s) => s.setTempVars);
  useEffect(() => {
    if (policyTarget && policyTarget !== null) {
      setTempVars({
        targetObjects: policyTarget.targetObjects,
        targetProfiles: policyTarget.targetProfiles,
        targetCommunities: policyTarget.targetCommunities,
      });
    }
  }, []);
  return (
    <>
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        {holderType === PolicyHolderTypeEnum.ATP ? (
          <AppsTargetSalesforceProduction />
        ) : (
          <ObjectsTargetSalesforceProduction />
        )}
      </Flex>
      <Flex mt="23px" alignItems="flex-start" ml="152px">
        <ProfilesTargetSalesforceProduction />
      </Flex>
    </>
  );
};

const General = () => {
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={false}
        rmsEnabledShow={false}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <TargetProduction />
    </Box>
  );
};
export default React.memo(General);
